export { default as Img200 } from './processed/200/Walking-Dead-The-S9B.jpg';
export { default as Img400 } from './processed/400/Walking-Dead-The-S9B.jpg';
export { default as Imgthumb } from './processed/thumb/Walking-Dead-The-S9B.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Walking-Dead-The-S9B.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Walking-Dead-The-S9B.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      173,
      113,
      82
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      92,
      60,
      44
    ],
    "_population": 6,
    "_hsl": [
      0.05555555555555555,
      0.35294117647058826,
      0.26666666666666666
    ]
  },
  "Muted": {
    "_rgb": [
      148,
      153,
      140
    ],
    "_population": 3047,
    "_hsl": [
      0.23076923076923062,
      0.059907834101382416,
      0.5745098039215686
    ]
  },
  "LightMuted": {
    "_rgb": [
      189,
      191,
      178
    ],
    "_population": 3029,
    "_hsl": [
      0.1923076923076922,
      0.09219858156028375,
      0.7235294117647059
    ]
  },
  "DarkMuted": {
    "_rgb": [
      92,
      52,
      44
    ],
    "_population": 1,
    "_hsl": [
      0.027777777777777776,
      0.35294117647058826,
      0.26666666666666666
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Walking-Dead-The-S9B.js